import React from 'react';
import { FiChevronLeft } from 'react-icons/fi';

const s = {
    pageHeader: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        marginBottom: '18px',
        flexWrap: 'wrap',
        gap: '12px',
    },
    headerLeft: {
        display: 'flex',
        alignItems: 'center',
        gap: '14px',
    },
    btnBack: {
        display: 'inline-flex',
        alignItems: 'center',
        gap: '5px',
        padding: '7px 16px',
        fontSize: '13px',
        fontWeight: '600',
        color: '#1a7d3e',
        backgroundColor: '#fff',
        border: '1.5px solid #bbf7d0',
        borderRadius: '8px',
        cursor: 'pointer',
        transition: 'all 0.15s ease',
        whiteSpace: 'nowrap',
    },
    pageTitleRow: {
        display: 'flex',
        alignItems: 'center',
        gap: '10px',
    },
    pageTitleIcon: {
        width: '36px',
        height: '36px',
        borderRadius: '9px',
        background: 'linear-gradient(135deg, #1a7d3e 0%, #34a85a 100%)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexShrink: 0,
        boxShadow: '0 2px 8px rgba(26,125,62,0.25)',
    },
    pageTitle: {
        fontSize: '18px',
        fontWeight: '700',
        color: '#111827',
        margin: 0,
    },
    countBadge: {
        fontSize: '12px',
        fontWeight: '600',
        color: '#1a7d3e',
        backgroundColor: '#dcfce7',
        borderRadius: '20px',
        padding: '2px 10px',
    },
};

/**
 * Shared page header with back button, gradient icon, title, and optional count badge.
 *
 * Props:
 *   onBack       {function}  – called when Back is clicked
 *   icon         {ReactNode} – icon inside the green gradient square
 *   title        {string}    – page title
 *   count        {number|string} – optional badge shown after title
 *   rightContent {ReactNode} – optional content for the right side (buttons, search, etc.)
 */
const PageHeader = ({ onBack, icon, title, count, rightContent }) => (
    <div style={s.pageHeader}>
        <div style={s.headerLeft}>
            <button
                style={s.btnBack}
                onMouseEnter={e => { e.currentTarget.style.backgroundColor = '#f0fdf4'; }}
                onMouseLeave={e => { e.currentTarget.style.backgroundColor = '#fff'; }}
                onClick={onBack}
            >
                <FiChevronLeft size={15} />
                Back
            </button>

            <div style={s.pageTitleRow}>
                <div style={s.pageTitleIcon}>{icon}</div>
                <h5 style={s.pageTitle}>{title}</h5>
                {(count !== undefined && count !== null) && (
                    <span style={s.countBadge}>{count}</span>
                )}
            </div>
        </div>

        {rightContent && <div>{rightContent}</div>}
    </div>
);

export default PageHeader;
